<script>
import Layout from '@layouts/main.vue'
import texts from '../../assets/data/localisations.json'

export default {
  components: { Layout },
  data() {
    return {
      texts: null,
      emptyInput: false,
      username: '',
      keyboardActive: false,
      showErrorMessage: false,
      showSuccessMessage: false,
      animated: false,
      inTouchZone: true,
      policyUrl: 'https://hyperdotstudios.com/policy/en',
    }
  },
  page: {
    title: 'Contact',
    meta: [{ name: 'description', content: 'The Contact page.' }],
  },
  computed: {
    platform() {
      return this.$store.getters['globals/platform']
    },
    allMessages() {
      return this.$store.getters['topics/allMessages']
    },
    params() {
      return this.$store.getters['globals/params']
    },
    locale() {
      return this.$store.getters['globals/locale']
    },
    consentPopup() {
      return this.$store.getters['globals/consentPopup']
    },
  },
  created() {
    this.texts = texts
  },
  methods: {
    openExternalUrl() {
      if (event.handled === false) return
      event.stopPropagation()
      event.preventDefault()
      event.handled = true

      window.location = this.policyUrl
    },
    animate() {
      if (event.handled === false) return
      event.stopPropagation()
      event.preventDefault()
      event.handled = true

      this.animated = true
    },
    determineTouchzone() {
      // handle touch zone bounding box
      // this is important so we can properly distinguish between "hovering" over button and clicks
      var touch = event.touches[0] || event.changedTouches[0]

      const btn = this.$refs.btn
      const rect = btn.getBoundingClientRect()
      const x = touch.clientX
      const y = touch.clientY

      if (
        rect.top + rect.height > y &&
        rect.top < y &&
        rect.left < x &&
        rect.left + rect.width > x
      )
        this.inTouchZone = true
      else this.inTouchZone = false
    },
    submitConsent() {
      if (event.handled === false) return
      event.stopPropagation()
      event.preventDefault()
      event.handled = true

      if (this.username.length === 0) {
        this.emptyInput = true
      } else {
        this.emptyInput = false
      }
      this.determineTouchzone()
      this.animated = false
      if (this.inTouchZone && !this.emptyInput) {
        this.$store
          .dispatch('topics/postConsent', {
            discordUsername: this.username,
            accepted: true, // true, false, null
            consentPopupType: this.consentPopup,
          })
          .then(() => {
            this.setCookie('o7_discordscreen', 'passed', 1)
            // send user to discord
            this.openUrl('https://discord.com/invite/4GXtr3WKgd')
          })
      }
    },
    skipConsent() {
      if (event.handled === false) return
      event.stopPropagation()
      event.preventDefault()
      event.handled = true

      this.$store
        .dispatch('topics/postConsent', {
          discordUsername: null,
          accepted: false, // true, false, null
          consentPopupType: this.consentPopup,
        })
        .then(() => {
          this.setCookie('o7_discordscreen', 'passed', 1)
          // send user to discord
          this.openUrl('https://discord.com/invite/4GXtr3WKgd')
        })
    },
    setCookie(cname, cvalue, exdays) {
      var d = new Date()
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
      var expires = 'expires=' + d.toUTCString()
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
    },
    openUrl(url) {
      if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.userSupport
      ) {
        window.webkit.messageHandlers.userSupport.postMessage({
          onOpenUrl: url,
        })
      } else {
        window.open(url, '_blank')
      }
      this.$router.push({ name: 'faq' })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="discord-consent">
      <div class="logo hd" />
      <img
        class="header"
        alt="Mythic Legends"
        :src="require('../../assets/images/ml_image.png')"
      />
      <div :class="['discord-input', emptyInput ? 'error' : '']">
        <div class="discord-input-left">
          <img
            class="discord-icon"
            alt="Discord"
            :src="require('../../assets/images/discord.svg')"
          />
        </div>
        <div class="discord-input-right">
          <input v-model="username" placeholder="Discord Username" />
        </div>
      </div>
      <div v-if="consentPopup === 'discord-consent-eea'" class="na_text">
        By clicking the submit button you agree to share your Discord username
        with Outfit7 Neo Limited so we are able to provide more insightful
        customer support, and to recognise you as our user in the Discord
        community channel. You can withdraw your consent at any time by writing
        to us at <span>support@mythic-legends.com</span>.
      </div>
      <div class="footer">
        <div class="global_consent_options">
          <div
            ref="btn"
            :class="['btn', 'green', animated ? 'btn_effect' : '']"
            @touchstart="animate"
            @touchmove="determineTouchzone"
            @touchend="submitConsent"
            @click="submitConsent"
          >
            <span>Submit</span>
          </div>
        </div>
      </div>
      <div class="pp_text">
        <div class="external_link">
          <div class="span" @touchstart="skipConsent" @click="skipConsent">
            Don’t share username, skip to Discord
          </div>
        </div>
        <div class="external_link">
          <div
            class="span"
            @touchstart="openExternalUrl"
            @click="openExternalUrl"
          >
            Privacy Policy
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss">
.discord-consent {
  font-family: 'Amsi Pro Cond';
  background: #241720;
  width: 100%;
  overflow: hidden;
  position: relative;
  @media (max-width: 960px) {
    min-height: calc(100vh - 48px);
  }
  @media (max-width: 600px) {
    min-height: calc(100vh - 56px);
  }
  @media screen and (min-width: 760px) {
    min-height: calc(100vh - 100px);
  }

  .logo {
    height: 34px;
    max-width: 130px;
    margin: 40px auto 0 auto;
    &.hd {
      width: 120px;
      background-image: url('../../assets/images/hds-logo.svg');
      background-repeat: no-repeat;
      background-size: contain;
    }
  }
  .header {
    display: block;
    width: 190px;
    height: auto;
    margin: 0 auto;
  }
  .v-lazy-image {
    filter: blur(10px);
    transition: filter 0.7s;
  }
  .v-lazy-image-loaded {
    filter: blur(0);
  }
  .title {
    width: 100%;
    display: inline-block;
    margin: 20px 0;
    font-family: 'Amsi Pro Cond';
    font-size: 2em;
    line-height: 1em;
    color: #f3bf76;
    text-align: center;
    text-transform: uppercase;
    @media screen and (min-width: 768px) {
      font-size: 3em;
    }
    @media screen and (min-width: 1024px) {
      font-size: 5em;
    }
  }
  .discord-input {
    border: 2px solid #a28c6a;
    position: relative;
    border-radius: 8px;
    width: 280px;
    height: 40px;
    margin: 20px auto;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    &.error {
      border: 2px solid red;
    }
    .discord-input-left {
      display: flex;
      background: #5865f2;
      width: 70px;
      height: 100%;
      img {
        width: auto;
        height: 25px;
        display: block;
        align-self: center;
        margin: 0 auto;
      }
    }
    .discord-input-right {
      width: 100%;
      height: 100%;
      background-color: #fdf0d7;
      input {
        height: 100%;
        width: 100%;
        background: transparent;
        border: none;
        color: #382331;
        padding-left: 10px;
        &::placeholder {
          color: rgba(56, 35, 49, 0.5);
        }
      }
    }
  }
  .na_text {
    padding: 0 20px 10px 20px;
    font-family: 'Amsi Pro Cond';
    font-size: 1em;
    color: #eadacb;
    text-align: center;
    margin: 0;
    span {
      color: #f3bf76;
      text-decoration: underline;
    }
    @media screen and (min-width: 768px) {
      font-size: 1.4em;
      padding: 0 30px 20px 30px;
    }
    @media screen and (min-width: 1024px) {
      font-size: 1.8em;
    }
  }
  .pp_text {
    position: absolute;
    width: 100%;
    bottom: 5px;
    padding: 0 0 10px 0;
    font-family: 'Amsi Pro Cond';
    font-size: 1em;
    color: #eadacb;
    text-align: center;
    @media screen and (min-width: 768px) {
      font-size: 1.4em;
    }
    @media screen and (min-width: 1024px) {
      font-size: 1.8em;
    }
  }
  .footer {
    position: relative;
    background: transparent;
    box-shadow: none;
    display: block;
    align-items: center;
    padding: 10px 20px 20px 20px;

    .global_consent_options {
      margin: 10px 0 0 0;
      display: flex;
      justify-content: space-around;
      width: 100%;

      .btn_effect {
        transform: scale(0.9);
      }

      .btn {
        display: flex;
        align-items: center;
        width: 94px;
        height: 40px;
        font-family: 'Amsi Pro Cond';
        text-align: center;
        text-transform: uppercase;
        background-image: url('../../assets/images/button-green.png');
        background-repeat: no-repeat;
        background-size: contain;
        transition: all 0.2s ease-in-out;
        margin: 10px 0 50px;
        justify-content: space-around;
        color: #614c49;
        @media screen and (min-width: 360px) {
          width: 110px;
          height: 48px;
        }
        @media screen and (min-width: 768px) {
          width: 165px;
          height: 72px;
        }
        @media screen and (min-width: 1024px) {
          width: 220px;
          height: 96px;
        }
        span {
          display: inline-block;
          width: 90%;
          font-size: 0.9em;
          line-height: 1.1em;
          @media screen and (min-width: 360px) {
            font-size: 1.1em;
          }
          @media screen and (min-width: 768px) {
            font-size: 1.8em;
          }
          @media screen and (min-width: 1024px) {
            font-size: 2.3em;
          }
        }
        &.grey {
          background-image: url('../../assets/images/button-sand.png');
          background-repeat: no-repeat;
          background-size: contain;
        }
      }
    }
  }
  .external_link {
    display: block;
    .span {
      text-decoration: underline;
      color: #f3bf76;
      text-transform: uppercase;
    }
  }
}
</style>
